import globalStyles from '../../styles/ButtonGradient.module.css';
import { FiPlay } from 'react-icons/fi';

const StartTraitQuizButton = ({ onClick }) => {
  return (
    <button
      className={globalStyles.button}
      onClick={onClick || (() => console.log('Start TraitQuizButton clicked'))}
    >
      <FiPlay className={globalStyles.icon} />
      Start Trait Quiz
    </button>
  );
};

export default StartTraitQuizButton;